$(document).ready(function(){
	
	$(".showhide").hide();
  $(".showmore").show();

  /* FAQ */
  $('.showmore').on('click', function(){
    $(this).next(".showhide").slideToggle();
  });
  
  ptStartShopCurrencyLoad();
});

var ptLandingCurrencyLoaded = function(){
  $('#averagecostpervisit').html(ptNumber.sprintNumber(ptShop.prices.roi.averagecostpervisit, 0, true));
  $('#averagesavingspermonth').html(ptNumber.sprintNumber(ptShop.prices.roi.averagesavingspermonth, 0, true));
};

$(document).on('ptShopCurrencyLoaded',  ptLandingCurrencyLoaded );